import { CvApi } from "../services/cv-api";
import { Info, Contact } from "@/types/info";

export interface InfoState {
  info: Info;
}

const state: InfoState = {
  info: <Info>{}
};

const mutations = {
  setInfo(state: InfoState, info: Info) {
    state.info = info;
  },
  appendDescription(state: InfoState, str: string) {
    state.info.description = state.info.description += str;
  }
};
const getters = {
  description: (state: InfoState): String => state.info.description,
  avatar: (state: InfoState): String | undefined => state.info.avatar,
  contact: (state: InfoState): Contact[] | undefined => state.info.contact,
  tags: (state: InfoState): string[] | undefined => state.info.tags
};
const actions = {
  fetchInfo({ commit, state }: { commit: any; state: InfoState }) {
    if (Object.keys(state.info).length == 0) {
      const info = CvApi.getInfo();
      // check error
      commit("setInfo", info);
    }
  },
  appendInfo({ commit, state }: { commit: any; state: InfoState }) {
    commit("appendDescription", "1");
  }
};

export const info = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
